import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-12 md:py-16 lg:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm font-medium mb-3">
            <i className="ri-sparkling-line"></i>
            <span>主题合集</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            编辑团队精心策划的主题漫画合集，一次性满足你对韩漫、日漫、国漫特定题材的深度探索需求
          </p>
        </div>

        {/* All 4 items displayed at once - no carousel behavior */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all"
            >
              <div className="img-container aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  onError={(e) => {
                    const container = e.currentTarget.closest('.img-container');
                    if (container) container.classList.add('hidden');
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 lg:p-6">
                <span className="inline-block px-2 py-0.5 rounded bg-accent-500 text-background-50 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg lg:text-xl font-bold text-background-50 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-background-200/90 mb-2">{item.subtitle}</p>
                <p className="text-xs md:text-sm text-background-200/70 line-clamp-2 leading-relaxed hidden sm:block">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}